import { useMemo } from "react";

import { useAuth } from "@/features/auth/hooks/useAuth";

import { hasMarketplaceAdminBundleAccess } from "../lib/marketplace-admin-bundle-access";

/**
 * True when the active org is the platform tenant with marketplace.admin
 * access. Matches `requireSuperTenantMarketplaceOrderOpsEditor`: org Admin
 * marketplace.admin PAGE must not unlock ETA/fulfilment edits, and switching
 * the sidebar to a client or partner org must not inherit Adge ops.
 */
export function useCanEditMarketplaceOrderFulfillment(): boolean {
  const tenants = useAuth((s) => s.tenants);
  const activeTenantId = useAuth((s) => s.activeTenantId);

  return useMemo(() => {
    const activeTenant =
      tenants.find((t) => t.id === activeTenantId) ?? tenants[0];
    if (!activeTenant || activeTenant.type !== "SUPER_TENANT") return false;

    return hasMarketplaceAdminBundleAccess(activeTenant.permissions);
  }, [tenants, activeTenantId]);
}
